import { useEffect, useMemo, useRef } from 'react'
import debounce from 'lodash/debounce'

type Callback = () => void

const useDebounce = (callback: Callback, wait: number = 300) => {
  const ref = useRef<Callback>()

  useEffect(() => {
    ref.current = callback
  }, [callback])

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.()
    }

    return debounce(func, wait)
  }, [wait])

  useEffect(() => {
    return () => {
      debouncedCallback.cancel()
    }
  }, [debouncedCallback])

  return debouncedCallback
}

export default useDebounce
